import React from "react";
import Image2 from "../../images/KUL-image1.jpg";
import Video1 from "../../images/KUL-video1.mp4";
import Video2 from "../../images/KUL-video2.mp4";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import FadeIn from "../ui/FadeIn";

const ProjectKUL = () => (
  <PageLayout>
    <PageHero title="Project-KUL" eyebrow="Kindness Unlimited Collective" light />
    <section className="ku-section bg-white py-12">
      {/* Removed extra spaces: using space-y-12 for a much tighter layout */}
      <div className="ku-container space-y-12 lg:space-y-16">
        
        {/* Block 1: Text Left, Image Right */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <FadeIn>
            <div className="ku-prose">
              <p>
                The Kindness Unlimited Collective was launched this academic year 2024-25. We have begun a pilot project with action research led by 2 TISS professors that will explore the correlation between &apos;volunteering and mental well-being&apos;. The experience also aims to empower undergraduate students with life skills learnt through service.
              </p>
            </div>
          </FadeIn>
          <FadeIn delay={0.1}>
            {/* Added max-w-md to keep the image proportioned to the text */}
            <img className="w-full max-w-md mx-auto block rounded-ku-lg shadow-elevated" src={Image2} alt="Project KUL" />
          </FadeIn>
        </div>

        {/* Block 2: Video Left, Text Right */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <FadeIn>
            {/* Added max-w-md to control the height of the portrait video */}
            <video className="w-full max-w-md mx-auto block rounded-ku-lg shadow-elevated" controls>
              <source src={Video1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </FadeIn>
          <FadeIn delay={0.1}>
            <div className="ku-prose">
              <p>
                The project began at two Mumbai colleges, Sophias and St. Andrews, where we have offered a planned 30 hours of volunteering followed by deep reflection sessions. We plan to have the research published by June 2025 and scale to other colleges.
              </p>
            </div>
          </FadeIn>
        </div>

        {/* Block 3: Text Left, Video Right */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <FadeIn>
            <div className="ku-prose">
              <p>
                The focus is on urban youth who are leaders of tomorrow. The objective is that a percentage of participating youth may continue to become lifelong volunteers and be of service, experience the joys of giving, and become more responsible citizens. The approach is threefold: K3 - Kindness to Self, Kindness to Others, and Kindness to the Environment. The focus is preferably on Kindness within the college and around the college pin code by contributing to the community and looking for opportunities to give and be of service.
              </p>
            </div>
          </FadeIn>
          <FadeIn delay={0.1}>
            {/* Added max-w-md to control the height of the portrait video */}
            <video className="w-full max-w-md mx-auto block rounded-ku-lg shadow-elevated" controls>
              <source src={Video2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </FadeIn>
        </div>

      </div>
    </section>
  </PageLayout>
);

export default ProjectKUL;